import 'isomorphic-fetch'
import config from '../../../../config/SiteConfig'

const dev = process.env.NODE_ENV !== 'production'
const server = dev ? '' : `${config.siteUrl}${config.pathPrefix}`
const request = async url => fetch(`${server}${url}`).then(response => response.json())

export default request



// WEBPACK FOOTER //
// ./src/components/Visualizations/util/request.js